export const extractSubmissionIdFromFilename = (filename) => {
  if (
    typeof filename !== "string" ||
    !filename.endsWith(".json") ||
    filename.length <= 5
  ) {
    throw new Error(`Invalid Submission filename: ${filename}`);
  }
  return filename.substring(0, filename.length - 5);
};

/**
 * Check if AI suggestions are available for a submission.
 *
 * @param {Object} submissionState - The submission state from Redux
 * @returns {boolean} True if AI suggestions are available
 */
export const hasAISuggestions = (submissionState) => {
  const ingestionData = submissionState?.aiSuggestions?.ingestionData;
  return ingestionData && Object.keys(ingestionData?.results || {}).length > 0;
};
